export default "__VITE_ASSET__1625efbb__"